import { getCustomTrackLayout } from "./track";

/** v1 compression-zone rules: inclusive 24-sample radius and a grounded
 * 72% normal-speed cap. v2 applies the ratio to its class/weight normal speed,
 * not a boost or rubber-band speed, so those cannot bypass the feature. */
export const CUSTOM_DIP_HALF_SAMPLES = 24;
export const CUSTOM_DIP_SPEED_RATIO = 0.72;

export function isInsideCustomTrackDip(distance: number, trackId: string): boolean {
  const layout = getCustomTrackLayout(trackId);
  if (!layout?.definition.dips?.length || !Number.isFinite(distance)) return false;
  const wrapped = ((distance % layout.length) + layout.length) % layout.length;
  const count = layout.samples.length - 1;
  let low = 0, high = count;
  while (low < high) {
    const middle = (low + high) >> 1;
    if (layout.samples[middle].distance < wrapped) low = middle + 1;
    else high = middle;
  }
  const previous = Math.max(0, low - 1);
  const index = (wrapped - layout.samples[previous].distance < layout.samples[low].distance - wrapped ? previous : low) % count;
  for (const progress of layout.definition.dips) {
    const centre = Math.round(progress * count) % count;
    const delta = Math.abs(index - centre);
    if (Math.min(delta, count - delta) <= CUSTOM_DIP_HALF_SAMPLES) return true;
  }
  return false;
}
